<template>
<div class="couponReceiveLayer_ui" v-if="isGuideLayer&&coupons.length>0">
    <div class="received-coupon-layer">
        <div class="received-sola-coupon-box" v-if="couponActivityConfig.showStyle==1">
            <div class="received-coupon-info">
                <div class="coupon-logo">
                    <img :src="coupons[0].listPicture+'?imageView2/1/w/328/h/173/q80/format/webp&x-oss-process=image/resize,m_fill,w_328,h_173'">
                </div>
                <div class="toCoupon" @click="toCouponList">
                    我的优惠券<i class="iconfont icongengduo1"></i>
                </div>
                <div class="coupon-name">{{coupons[0].name}}</div>
                <div class="coupon-desc">{{coupons[0].secondName}}</div>
                <div class="coupon-btn" @click="chooseCouon(coupons[0])">
                    <img src="https://xcx.ihotel.cn/mall/images/coupon/receivedCoupon_btn.png" v-if="coupons[0].canReceived=='T'">
                    <img src="https://xcx.ihotel.cn/mall/images/coupon/receivedCoupon_btn2.png" v-else-if="coupons[0].alreadyReceived>0">
                </div>
                <div class="received-more" @click="goCouponCenter()">领取更多</div>
            </div>
            <div class="close" @click="closeLayer"><i class="iconshanchu1 iconfont"></i></div>
        </div>
        <div class="received-coupon-box" v-else>
            <div class="head">
                <img src="https://xcx.ihotel.cn/mall/images/coupon/receivedCoupon_head.png">
            </div>
            <div class="received-coupon-info">
                <div class="toCoupon" @click="toCouponList">
                    我的优惠券<i class="iconfont icongengduo1"></i>
                </div>
                <div class="received-coupon-list">
                    <div class="received-coupon-item" @click="chooseCouon(item)" v-for="(item,i) in coupons" :key="i">
                        <div class="received-coupon-item-lf">
                            <img class="img" :src="item.listPicture+'?imageView2/1/w/246/h/130/q80/format/webp&x-oss-process=image/resize,m_fill,w_246,h_130'">
                        </div>
                        <div class="received-coupon-item-rt">
                            <div class="coupon-item-name">{{item.name}}</div>
                            <div class="coupon-item-desc">{{item.secondName}}</div>
                        </div>
                        <div class="coupon-status" v-if="item.canReceived!='T'&&item.alreadyReceived>0">
                            <img src="https://xcx.ihotel.cn/mall/images/allReceive.png">
                            <img src="https://xcx.ihotel.cn/mall/images/receive_gery.png">
                        </div>

                    </div>
                </div>
                <div class="tips" @click="isTips()"><i class="iconfont" :class="{'iconyixuanze':tips}"></i>不再提醒</div>
                <div class="receiveBtn-box">
                    <img class="receiveBtn" src="https://xcx.ihotel.cn/mall/images/allReceive.png" @click="receiveSCCouponAll" v-if="number>0">
                    <img class="receiveBtn" src="https://xcx.ihotel.cn/mall/images/receive_gery.png" v-else>
                </div>
                
                <div class="received-more" @click="goCouponCenter()">领取更多</div>
            </div>
            <div class="close" @click="closeLayer"><i class="iconshanchu1 iconfont"></i></div>
        </div>

    </div>
</div>
</template>

<script>
import api from '@/utils/api';
import moment from 'moment';
import {
    setStorage,
    getStorage
} from '@/utils/wxuser';
import {
    jAlert3
} from '@/base/jAlert/jAlert';
import {
    urlEncode,
    createUrl
} from '@/utils/index';
import gcTrack from "@/utils/gcTrack";
var config = {};
export default {
    data() {
        return {
            wxuser: '',
            user: getStorage('user'),
            coupons: [],
            isTap: false,
            isAjax: true,
            hotelCode: 0,
            isReceivedCouponLayer: false,
            memberType: {},
            isGuideLayer: false,
            coupon: {},
            tips:false,
            allNumber:0,
            receiveNumber:0,
            pageName:'',
            number:0
        };
    },
    props: {
        couponActivityConfig: {
            type: Object,
            default () {
                return {};
            }
        }
    },
    methods: {
        isTips() {
            this.tips = !this.tips
            var ids = ''
            this.couponActivityConfig.activityList.forEach(item=>{
                ids += item.id+':'
            })
            if(this.tips){
                setStorage('closeReceive'+this.pageName,ids)
            }else{
                setStorage('closeReceive'+this.pageName,'')
            }
            
        },
        toCouponList() {
            this.$router.push({
                path: '/couponList'
            });
        },
        goCouponCenter() {
            this.$router.push({
                path: '/couponCenterNew'
            });
        },
        receiveSCCouponAll() {
            this.allNumber = 0;
            this.receiveNumber =0
             this.coupons.forEach((item) => {
                if (item.canReceived == 'T') {
                    this.allNumber++;
                }

            })
            this.coupons.forEach((item) => {
                if (item.canReceived == 'T') {
                    this.receiveSCCoupon(item)
                }

            })

        },
        receiveSCCoupon(item) {
            if (!this.user || !this.user.memberId) {
                this.isLogin();
                return;
            }
            var coupon = this.coupon
            if (item&&item.couponCode) {
                coupon = item
            }else{
                this.allNumber = 1;
            }
            var number = 0
            var rewardValues = []

            // if (this.isTap) {
            //     return false;
            // }
            // this.isTap = true;
            var obj = {
                couponCode: coupon.couponCode,
                hotelGroupCode: config.hotelGroupCode,
                hotelGroupId: config.hotelGroupId,
                memberId: this.user.memberId,
                hotelCode: coupon.hotelCode,
                appid: config.appid,
                openid: this.wxuser.openid,
                couponType: coupon.couponType,
                mobile: this.user.mobile,
                rewardValue: rewardValues.join(',')

            };
            this.getCurrentCard();
            var chuzhiIndex = getStorage("cardIndex") || 0;
            obj.cardId = this.user.cardListDto[chuzhiIndex].cardId;
            obj.cardLevel = this.user.cardListDto[chuzhiIndex].cardLevel;
            obj.cardNo = this.user.cardListDto[chuzhiIndex].cardNo;
            obj.url = createUrl(obj)
            api.receiveSCCouponNew(obj).then((res) => {
                this.isTap = false;
                if (res.result == 1) {
                    this.receiveNumber++
                    if(this.receiveNumber >= this.allNumber){
                        jAlert3('领取成功');
                         this.getCanReceivedList()
                    }
                    
                    gcTrack.track("SC_ReceiveDiscount", {
                        discount_id: coupon.id,
                        discount_name: coupon.name,
                        discount_amount: coupon.presentValue,
                        discount_type: coupon.couponType
                    })
                   
                    // this.coupons = [];
                    // this.closeLayer()

                } else {
                    jAlert3(res.msg);
                }
                console.log(res);
            });
        },
        chooseCouon(item) {
            if (item.canReceived != 'T') {
                return
            }
            this.coupon = item
            this.receiveSCCoupon()
        },
        goCouponInfo() {
            this.$router.push({
                path: '/couponInfo',
                query: {
                    hotelCode: this.coupon.hotelCode || 0,
                    activityId: this.coupon.id,
                },
            });
        },
        closeLayer() {
            this.isGuideLayer = false
        },
        getCanReceivedList(init) {

            if (!this.isAjax) {
                return false;
            }

            this.isAjax = false;
            api
                .getCanReceivedList({
                    hotelGroupCode: config.hotelGroupCode,
                    hotelGroupId: config.hotelGroupId,
                    memberId: this.user.memberId || "",
                    hotelCode: config.hotelCode,
                    cardLevel: this.user.cardLevel || "",
                })
                .then((res) => {
                    if (res.result == 1) {
                        this.coupons = [];
                        var number = 0
                        var activityList = this.couponActivityConfig.activityList
                        activityList.forEach((item) => {
                            res.retVal.forEach((n, i) => {
                                n.sta = "I";
                                n.isHide = true;
                                n.hexiaoRemark = n.couponDescribe;
                                if (n.ruleType == 'member') {
                                    n.buttonText = '立即查看';
                                } else {
                                    n.buttonText = '立即领取';
                                }
                                if (n.canReceived !== "T") {
                                    n.disableBtn = true;
                                    n.buttonText = "已领取";
                                }
                                if (n.vrEndDate && n.couponType == "coupon") {
                                    n.validToDate = moment(n.vrEndDate).format("YYYY-MM-DD");
                                }
                                if (n.couponType == "RF") {
                                    n.presentValue = (Number(n.presentValue) * 10).toFixed(0);
                                }

                                if (item.id == n.id) {
                                    if(n.canReceived=='T'){
                                        number++
                                    }
                                    this.coupons.push(n)
                                }
                            })
                            
                        });
                        

                    }
                    var ids = ''
                    this.couponActivityConfig.activityList.forEach(item=>{
                        ids += item.id+':'
                    })
                    if (init == 'T' && number > 0&&getStorage('closeReceive'+this.pageName)!=ids) {
                        this.isGuideLayer = true
                    }
                    this.number = number
                    this.isAjax = true;
                });
        },
    },
    created() {
        config = getStorage('config');
    },
    mounted() {
        this.pageName = this.$route.name 
        this.getCanReceivedList('T')

    }
}
</script>

<style lang="less" scoped>
@import url("~@/styles/base.less");
@import url("~@/styles/mixin.less");

.couponReceiveLayer_ui {
    position: fixed;
    z-index: 99;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(0, 0, 0, 0.50);

    .received-coupon-box {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 8.533333rem;

        .head {
            img {
                width: 100%;
            }
        }

        .received-coupon-info {
            margin-top: -1px;
            padding: 0 0.266667rem 0.4rem;
            background: #FF4A32;
            border-radius: 0px 0px 0.533333rem 0.533333rem;

            .title {
                font-family: PingFangSC-Medium;
                font-size: 14px;
                color: #FFFFFF;

                i {
                    margin-right: 0.08rem;
                }
            }

            .received-coupon-list {
                max-height: 8.533333rem;
                overflow-y: auto;

                .received-coupon-item {
                    position: relative;
                    display: flex;
                    align-items: center;
                    margin-top: 0.266667rem;
                    padding: 0.266667rem 1.2rem 0.266667rem 0.266667rem;
                    line-height: 1.4;
                    box-sizing: border-box;
                    width: 8rem;
                    height: 2.266667rem;
                    background: url(https://xcx.ihotel.cn/mall/images/coupon/receivedCoupon_bg.png) no-repeat;
                    background-size: contain;
                    overflow: hidden;
                    border-radius: 0.32rem;

                    .coupon-status {
                        background: rgba(255, 255, 255, 0.65);
                        position: absolute;
                        right: 0;
                        height: 100%;
                        left: 0.266667rem;
                        top: 0;

                        img {
                            position: absolute;
                            top: -0.266667rem;
                            right: 0;
                            width: 1.6rem;
                        }
                    }

                    .received-coupon-item-lf {
                        margin-right: 0.213333rem;

                        .img {
                            height: 1.733333rem;
                            width: 3.28rem;
                            border-radius: 6px;
                        }
                    }

                    .no-sell {
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 100%;
                        height: 100%;
                        background: rgba(255, 255, 255, 0.9);
                    }

                    .noAvail-box {
                        position: absolute;
                        left: 0;
                        right: 0;
                        top: 0;
                        bottom: 0;
                        background: rgba(255, 255, 255, 0.80);
                    }

                    &.noAvail {
                        .noAvail-box {
                            display: block;
                        }

                    }

                    .received-coupon-item-rt {
                        flex: 1;

                        .coupon-item-name {
                            font-family: PingFangSC-Medium;
                            font-size: 14px;
                            color: #333333;

                            letter-spacing: 0;
                            font-weight: 600;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 1;
                            white-space: normal;
                            overflow: hidden;
                        }

                        .coupon-item-desc {
                            padding-right: 0.266667rem;
                            margin-top: 0.16rem;
                            font-family: PingFangSC-Regular;
                            font-size: 12px;
                            color: #666666;
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 1;
                            white-space: normal;
                            overflow: hidden;
                        }
                    }

                    .received-coupon-btn {
                        i {
                            font-size: 28px;
                            color: #FF4A32;

                        }
                    }
                }
            }

            .go-received-coupon-info {
                margin-top: 0.266667rem;
                text-align: center;
                font-family: PingFangSC-Semibold;
                font-size: 14px;
                color: #FFFFFF;
                letter-spacing: 0;
                font-weight: 600;
            }

        }

        .toCoupon {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding-top: 0.133333rem;
            color: #fff;
            text-align: right;
            font-size: 12px;
            opacity: 0.75;

            i {
                font-size: 10px;
            }

        }

        .close {

            display: flex;
            justify-content: center;

            i {
                margin-top: 0.4rem;
                background: rgba(255, 255, 255, 0.2);
                border-radius: 50%;
                font-size: 30px;
                color: #fff;
            }
        }

        .received-more {
            text-align: center;
            margin-top: 0.32rem;
            font-size: 12px;
            color: #FFFFFF;
            font-weight: bold;
        }
    }

    .received-sola-coupon-box {
        margin-top: -1.333333rem;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 8.533333rem;
        height: 9.733333rem;
        background: url(https://xcx.ihotel.cn/mall/images/coupon/receivedCoupon_bg2.png) no-repeat;
        background-size: contain;

        .coupon-logo {
            margin-top: 2.533333rem;
            text-align: center;

            img {
                width: 3.28rem;
                height: 1.733333rem;
                border-radius: 2px;
            }
        }

        .toCoupon {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin-top: 1.6rem;
            padding: 0 1.6rem;
            color: #fff;
            text-align: right;
            font-size: 12px;
            opacity: 0.75;

            i {
                font-size: 10px;
            }

        }

        .coupon-name {
            padding: 0 1.6rem;
            margin-top: 0.266667rem;
            text-align: center;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            white-space: normal;
            overflow: hidden;
            font-family: PingFangSC-Semibold;
            font-size: 15px;
            color: #FFFFFF;
            font-weight: bold;
            line-height: 1.3;
        }

        .coupon-desc {
            line-height: 1.3;
            margin-top: 0.133333rem;
            padding: 0 1.6rem;
            font-size: 12px;
            color: rgba(255, 255, 255, 0.75);
            text-align: center;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1;
            white-space: normal;
            overflow: hidden;
        }

        .coupon-btn {
            margin-top: 0.266667rem;
            text-align: center;

            img {
                width: 4.533333rem;
            }

        }

        .received-more {
            text-align: center;
            margin-top: 0.32rem;
            font-size: 12px;
            color: #FFFFFF;
            font-weight: bold;
        }

        .close {

            display: flex;
            justify-content: center;
            margin-top: 0.4rem;

            i {
                margin-top: 0.4rem;
                background: rgba(255, 255, 255, 0.2);
                border-radius: 50%;
                font-size: 30px;
                color: #fff;
            }
        }
    }

    .received-coupon-btn-box {
        display: flex;
        justify-content: center;
        margin-top: 0.32rem;

        .received-coupon {
            position: relative;
            height: 1.173333rem;
            width: 4.8rem;

            .received-coupon-content {
                position: absolute;
                width: 4.8rem;
                top: 0;
                z-index: 2;
                display: flex;
                justify-content: center;
                align-items: center;

                height: 1.12rem;
                background-image: linear-gradient(270deg, #FACA5A 0%, #FAF0BC 100%);
                border-radius: 0.586667rem;
                font-family: PingFangSC-Semibold;
                font-size: 20px;
                color: #E41D02;
                letter-spacing: 0;
                text-align: center;
                font-weight: 600;
            }

            .received-coupon-bg {
                top: 0.053333rem;
                border-radius: 0.586667rem;
                position: absolute;
                left: 0;
                right: 0;
                height: 1.173333rem;
                width: 4.8rem;
                background: #F09B23;
            }
        }

    }
    .receiveBtn-box{
         display: flex;
        justify-content: center;
    }
    .receiveBtn{
        display: flex;
        justify-content: center;
        margin-top: 0.266667rem;
        width: 5.333333rem;
        height: 0.88rem;
    }
    .tips {
        margin-top: 0.266667rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
         color: #fff;

        i {
            display: flex;
            align-items: center;
            border: 1px solid #fff;
            width: 14px;
           
            height: 14px;
            font-size: 14px;
            box-sizing: border-box;
            color: #fff;
            margin-right: 0.186667rem;

            &.iconyixuanze {
                border: 0;
            }
        }
    }
    

}
</style>



// WEBPACK FOOTER //
// src/components/guideLayer.vue